import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { TextReveal } from './ui/Reveal';
const TESTIMONIALS = [{
  quote: 'Yetu gave Tende a face people trust in seconds — the brand and the app finally feel like the same product.',
  name: 'Abel',
  role: 'CEO, TendePay'
}, {
  quote: 'We finally look like the company we are. A mark people remember and a site that does the selling for us.',
  name: 'Amos',
  role: 'Co-founder, Nova Cloud'
}, {
  quote: 'The rebrand made us look like the premium studio we are. Bookings picked up almost immediately.',
  name: 'Lisa',
  role: 'Manager, Pixel Paints'
}, {
  quote: 'They turned a pile of spreadsheets into a product our customers actually love.',
  name: 'Doris',
  role: 'CEO, FlowKey Labs'
}];
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const visible = [0, 1, 2].map(offset => TESTIMONIALS[(index + offset) % TESTIMONIALS.length]);
  return <section className="relative z-10 w-full bg-black px-5 py-20 lg:px-8 lg:py-24" data-id="element-218" data-mp="m5b59r5dlyje">
      <div className="mx-auto w-full max-w-shell" data-id="element-219" data-mp="780ktsar9ibj">
        <div className="flex items-center justify-between gap-6" data-id="element-220" data-mp="79bqxyrob25t">
          <h2 className="text-3xl font-semibold leading-tight text-[#E3E3E3] lg:text-[40px]" data-id="element-221" data-mp="c6252gjx3nol">
            <TextReveal data-id="element-222" data-mp="zw64ebq2p19s">We are the best. Trust us on that.</TextReveal>
          </h2>
          <div className="flex shrink-0 gap-3" data-id="element-223" data-mp="14v99fw61z7hr">
            <button type="button" aria-label="Previous testimonial" onClick={() => setIndex(i => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)} className="rounded-full border border-white/20 p-3 text-white transition-colors hover:bg-white hover:text-black" data-id="element-224" data-mp="14uzh41xjco8w">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-225" data-mp="1nnbmkxjhk5n9" />
            </button>
            <button type="button" aria-label="Next testimonial" onClick={() => setIndex(i => (i + 1) % TESTIMONIALS.length)} className="rounded-full border border-white/20 p-3 text-white transition-colors hover:bg-white hover:text-black" data-id="element-226" data-mp="1xhh841b51lob">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-227" data-mp="1jkc2u3j90qu4" />
            </button>
          </div>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-228" data-mp="19sepor8ojosr">
          <AnimatePresence mode="popLayout" initial={false} data-id="element-229" data-mp="19qbtfpgxozfl">
            {visible.map(testimonial => <motion.li key={testimonial.name} layout initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -16
          }} transition={{
            duration: 0.35,
            ease: 'easeOut'
          }} className="flex flex-col justify-between gap-8 rounded-2xl bg-[#141414] p-7" data-id="element-230" data-mp="14qz7d6xvzwe2">
                <blockquote className="text-lg font-semibold leading-7 text-[#ECECEC]" data-id="element-231" data-mp="37g0fnckq6m5x">
                  “{testimonial.quote}”
                </blockquote>
                <div className="flex items-center gap-3" data-id="element-232" data-mp="3cfle7lvzgsi4">
                  <span aria-hidden="true" className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0000FE] text-sm font-semibold text-white" data-id="element-233" data-mp="3gh6yvtereb2v">
                    {testimonial.name.charAt(0)}
                  </span>
                  <div data-id="element-234" data-mp="2srcnzhe02wl9">
                    <p className="text-sm font-semibold text-white" data-id="element-235" data-mp="2squl41wu1k4d">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-[#939598]" data-id="element-236" data-mp="2xj438vrphfw3">{testimonial.role}</p>
                  </div>
                </div>
              </motion.li>)}
          </AnimatePresence>
        </ul>
      </div>
    </section>;
}